import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ingredientesService } from '../services/ingredientesService';

export const useCategorias = () => {
  return useQuery({
    queryKey: ['categorias'],
    queryFn: () => ingredientesService.getCategorias(),
    staleTime: 1000 * 60 * 60, // 1 hora (las categorías no cambian frecuentemente)
  });
};

export const useCreateCategoria = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { nombre: string; descripcion?: string }) =>
      ingredientesService.createCategoria(data.nombre, data.descripcion),
    onSuccess: () => {
      // Invalidar cache de categorías para recargarlas
      queryClient.invalidateQueries({ queryKey: ['categorias'] });
    },
  });
};
